import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PathError } from '@web/app/shared';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';

import { Button } from '@codes/ui-kit';

interface ErrorPageProps {
    error: PathError;
    onRetry?: () => void;
}

export const ErrorPage = ({ error, onRetry }: ErrorPageProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/', { replace: true });
    };

    const handleRetry = () => {
        if (onRetry) {
            onRetry();
        } else {
            window.location.reload();
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <div className="flex flex-col items-center gap-6 max-w-md text-center px-6">
                <div className="w-16 h-16 rounded-full bg-error/15 flex items-center justify-center">
                    <AlertTriangle className="w-8 h-8 text-error" />
                </div>

                <div className="space-y-2">
                    <h1 className="text-2xl font-semibold text-gray-900">{t('pathError.title')}</h1>
                    <p className="text-gray-600">{t(`pathError.${error}`)}</p>
                </div>

                <div className="flex gap-3 w-full">
                    <Button variant="outline" onClick={handleRetry} className="flex-1 gap-2">
                        <RefreshCw className="w-4 h-4" />
                        {t('common.retry')}
                    </Button>
                    <Button onClick={handleGoHome} className="flex-1 gap-2">
                        <Home className="w-4 h-4" />
                        {t('common.goHome')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
